/* src/app/order/partials/order-simple-form/order-simple-form.component.scss */
/*# sourceMappingURL=order-simple-form.component.css.map */
